import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableActions from 'portaltransparencia-common/components/TableActions.react';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';
import configuration from 'portaltransparencia-common/config/Config.js';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { DisplayData } from '@elotech/components';

function AnexoRow({ anexo, index }) {
  const id = anexo.get('id');
  const nome = anexo.get('nome') || 'Arquivo sem título';
  const tamanho = NumberUtils.formatBytes(anexo.get('tamanhoArquivo'));

  const handleDownload = () => {
    window.open(`${configuration.apiURL}/api/files/arquivo/${id}`, '_blank');
  };

  return (
    <TableActions key={id || index} data={id} onDownload={handleDownload}>
      <td id="nomeAnexo">{`${nome} ${tamanho}`}</td>
    </TableActions>
  );
}

AnexoRow.propTypes = {
  anexo: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};

export default function FormDetailAnexos({ anexos }) {
  const items = anexos || List();

  if (items.size === 0) {
    return <p className="text-muted">Nenhum anexo informado.</p>;
  }

  return (
    <DisplayData border title={''}>
      <table className="panel-table striped fancy">
        <TableHeader empty={items.isEmpty()} text="Não há arquivos.">
          <tr>
            <th>Nome do Arquivo</th>
            <th />
          </tr>
        </TableHeader>
        <tbody>
          {items.map((anexo, index) => (
            <AnexoRow
              key={anexo.get('id') || index}
              anexo={anexo}
              index={index}
            />
          ))}
        </tbody>
      </table>
    </DisplayData>
  );
}

FormDetailAnexos.propTypes = {
  anexos: PropTypes.object
};
